import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Card, Modal, Col, Radio, Image, Row, Table, Typography, notification, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    CheckCircleTwoTone,
    LockFilled,
    UnlockFilled,
    EyeFilled,
    EditFilled,
    LinkOutlined,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import Text from 'antd/es/typography/Text';
import Parameters from 'shared/parameters';
import { split } from 'apollo-boost';

import arrowLeft from '../../../src/img/arrow-left.png';
import activeBadge from '../../../src/img/active-badge.png';
import inactiveBadge from '../../../src/img/inactive-badge.png';
import lockOpen from '../../../src/img/lock-open.png';
import viewIcon from '../../../src/img/view-icon.png';
import editIcon from '../../../src/img/edit-icon.png';
import plusIcon from '../../../src/img/plus.png';
import deFlag from '../../../src/img/de-icon.png';
import { AuthConsumer } from 'shared/contexts/AuthContext';

// import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

interface Props {
    location: any;
}

const { Title, Link } = Typography;
const { confirm } = Modal;
export default function UsersPage(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();

    const [deletingItem, setDeletingItem] = useState(false);
    const [activeTab, setActiveTab] = useState('STUDENT');
    const [items, setItems] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const [lang, setLang] = useState('' as any);

    // const [searchInput, setSearchInput] = useState('');
    // const [filteredResults, setFilteredResults] = useState([] as any[]);
    // const searchItems = (searchValue:any) => {
    //     console.log(searchValue)
    //     setSearchInput(searchValue)
    //     if (searchValue !== '') {
    //         const filteredData = items.filter((item) => {
    //             return Object.values(item.name).join('').toLowerCase().includes(searchValue.toLowerCase())
    //         })
    //          console.log(filteredData)
    //          setFilteredResults(filteredData)
    //     }
    //     else{
    //          setFilteredResults(items)
    //     }
    // }
    const refreshItems = async () => {
        try {
            setFetching(true);
            const params: any = { order_by: 'id', page: 1, order: 'DESC' };
            
                params['type'] = 'student';
            
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchUsers(params);
            setItems(items);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#studentList').DataTable({
                    "language": {
                        "search": t('genDict.dataTableSearch'),
                      //   "emptyTable": "No data available in table"
                        "emptyTable": t('genDict.emptyTable'),
                        "lengthMenu": t('genDict.Show') + " _MENU_ " + t('genDict.entries'),
                        "paginate": {
                            "first":      t('genDict.first'),
                            "last":       t('genDict.last'),
                            "next":      t('genDict.next'),
                            "previous":   t('genDict.previous'),
                          },
                          "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                    
                      "infoEmpty": t('genDict.infoEmpty'),
                      }
                });
                // } ,1500);
            });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        refreshItems();
        setLang(localStorage.getItem('language'));
    }, [activeTab]);
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    history.push('/login')
                ) : (
                    <div className={'list-page-wrapper'}>
                        <div className="container-fluid">
                            <div className={'d-flex justify-space-between mb-3'}>
                                <div className='p-0 d-flex align-items-center'>
                                    <div className={lang == 'ar' ? '' : 'mr-4'}>
                                    <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                                    </div>
                                    <div className={lang == 'ar' ? 'ml-2' : ''}><h3 className='mb-0'>{t('genDict.students')}</h3></div>
                                </div>
                                <div className={lang == 'ar' ? 'mr-2 text-sm-right' : 'text-sm-right'}>
                                    <Button className="btn btn-blue text-capitalize" onClick={() => history.push('/student/create')}>
                                        {/* <span className='d-flex align-items-center'><img src={plusIcon} className="mr-1"/>{t('genDict.add')+' student'}</span> */}
                                        <span className='d-flex align-items-center'><img src={plusIcon} className={lang == 'ar' ? 'ml-2' : 'mr-2'}/>{t('genDict.AddStudent')}</span>
                                    </Button>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12 p-0'>
                                    <div className='bg-white p-3 br-5px'>
                                        <div className="row mt-2">
                                            
                                            {/* <div className='col-lg-12 mb-2'>
                                                <div className='float-right d-flex align-items-center' style={{flexWrap:'nowrap'}}>
                                                    <span className='mr-2' style={{whiteSpace:'nowrap'}}>Search student</span>  
                                                    <input type='text' name="" id="" 
                                                    onChange={(e) => searchItems(e.target.value)} 
                                                    placeholder='Enter Student Name' className='form-control'/>
                                                </div>
                                            </div> */}
                                        <div className="col-md-12 pb-3">
                                            <div className="table-responsive table-br-5 box-shadow mt-2">
                                                <table id="studentList" className="table  table-meetings table-report">
                                                <thead>
                                                    <tr>
                                                    <th className="text-uppercase text-secondary">{t('genDict.StudentName')}</th>
                                                    {/* <th className="text-uppercase text-secondary">Courses</th> */}
                                                    <th className="text-uppercase text-secondary">{t('genDict.email')}</th>
                                                    <th className="text-uppercase text-secondary">{t('genDict.phone')}</th>
                                                    <th className="text-uppercase text-secondary text-center">{t('genDict.status')}</th>
                                                    <th className="text-uppercase text-secondary" style={{width:'150px'}}>{t('genDict.AddIn')}</th>
                                                    <th className="text-uppercase text-secondary" style={{width:'100px'}}>{t('genDict.action')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        // searchInput.length > 1 ?
                                                        // filteredResults && filteredResults.map(filtureddata => {
                                                        //     return <tr>
                                                        // <td>
                                                        // <div className="d-flex align-items-center">
                                                        // {filtureddata.avatar_image !== null ?
                                                        //         <div className="mr-3">
                                                        //             <img src={Parameters.ImageBaseUrl + filtureddata.avatar_image.slug + filtureddata.avatar_image.ext} className="uploaded-img-cat" height="40" width="40"/>
                                                        //         </div>
                                                        //         :
                                                        //         <div className="mr-3">
                                                        //             <img src={Parameters.ImageBaseUrl + 'avatar.png'} className="uploaded-img-cat" height="40" width="40"/>
                                                        //         </div>
                                                        //     }
                                                        //     <div className="">
                                                        //         <p className="mb-0"><span>{filtureddata?.name ? filtureddata.name :<></> }</span></p>
                                                        //     </div>
                                                        //     </div>
                                                        // </td>
                                                        // {/* <td className="text-secondary">
                                                        // <a type="button" className="text-blue" data-toggle="modal" data-target={`#myModal${filtureddata.id}`}>
                                                        //     View Courses
                                                        //     </a>
                                                        //     <div className="modal" id={`myModal${filtureddata.id}`}>
                                                        //     <div className="modal-dialog centered m-0" style={{maxWidth:'500px',transform: "translate(-50%, -50%)"}}>
                                                        //         <div className="modal-content">
                                                        //         <div className="modal-header">
                                                        //             <h4 className="modal-title">Enrolled Courses</h4>
                                                        //             <button type="button" className="close" data-dismiss="modal">&times;</button>
                                                        //         </div>
                                                        //         <div className="modal-body">
                                                        //         {filtureddata.coursesOpted && filtureddata.coursesOpted.map((optedCourse:any) => {
                                                        //             return <>{optedCourse && optedCourse?.title ? optedCourse.title+', ':''}</>
                                                        //         })}
                                                        //         </div>
                                                        //         </div>
                                                        //     </div>
                                                        //     </div>
                                                        // </td> */}
                                                        // <td className="text-secondary">{filtureddata.email}</td>
                                                        // <td className="text-secondary">{filtureddata.phone}</td>
                                                        // <td className="text-center">{filtureddata.status === 'ACTIVE'? <img src={activeBadge}/>: <img src={inactiveBadge}/>}</td>
                                                        // <td className="text-secondary">{moment(filtureddata.created_at).format('DD MMMM, YYYY')}</td>
                                                        // <td className="text-secondary">
                                                        //     <div className='d-flex align-items-center'>
                                                        //         <div className='mr-3'>
                                                        //         {
                                                        //             filtureddata.status === 'INACTIVE' ?
                                                        //                 <Button shape={'circle'} className='btn-danger' onClick={() => {
                                                        //                     API_SERVICE.activateUser(filtureddata.id).then(() => {
                                                        //                         refreshItems();
                                                        //                     }).catch((e) => {
                                                        //                         notification.error({ message: API_SERVICE.handleErrors(e) });
                                                        //                     });
                                                        //                 }
                                                        //                 } icon={<LockFilled />} /> :
                                                        //                 <Button shape={'circle'} type={'primary'} onClick={() => {
                                                        //                     API_SERVICE.deactivateUser(filtureddata.id).then(() => {
                                                        //                         refreshItems();
                                                        //                     }).catch((e) => {
                                                        //                         notification.error({ message: API_SERVICE.handleErrors(e) });
                                                        //                     });
                                                        //                 }
                                                        //                 } icon={<UnlockFilled />} />
                                                        //         }
                                                        //             {/* <img className='cursor-pointer' src={lockOpen} style={{width:'15px'}} /> */}
                                                        //         </div>
                                                        //         <div className='mr-3'>
                                                        //             <img className='cursor-pointer' src={viewIcon} style={{width:'20px'}} 
                                                        //             onClick={() => {
                                                        //                 history.push(`/student/${filtureddata.id}/view`);
                                                        //             }}
                                                        //             />
                                                        //         </div>
                                                        //         <div className='mr-3'>
                                                        //             <img className='cursor-pointer' src={editIcon}  style={{width:'15px'}} 
                                                        //             onClick={() => {
                                                        //                 history.push(`/student/${filtureddata.id}/edit`);
                                                        //             }}
                                                        //             />
                                                        //         </div>
                                                        //     </div>
                                                        // </td>
                                                        // </tr>
                                                        // })
                                                        // :
                                                    items && items.map(item => {
                                                        console.log(item);
                                                        return <tr>
                                                        <td>
                                                        <div className="d-flex align-items-center">
                                                        {item.avatar_image !== null ?
                                                                <div className="mr-3">
                                                                    <img src={Parameters.ImageBaseUrl + item.avatar_image.slug + item.avatar_image.ext} className="uploaded-img-cat" height="40" width="40"/>
                                                                </div>
                                                                :
                                                                <div className="mr-3">
                                                                    <img src={Parameters.ImageBaseUrl + 'avatar.png'} className="uploaded-img-cat" height="40" width="40"/>
                                                                </div>
                                                            }
                                                            
                                                            <div className="">
                                                                <p className="mb-0"><span>{item?.name ? item?.name:<></>}</span></p>
                                                            </div>
                                                            </div>
                                                        </td>
                                                        {/* <td className="text-secondary">
                                                        <a type="button" className="text-blue" data-toggle="modal" data-target={`#myModal${item.id}`}>
                                                            View Courses
                                                            </a>
                                                            <div className="modal" id={`myModal${item.id}`}>
                                                            <div className="modal-dialog centered m-0" style={{maxWidth:'500px',transform: "translate(-50%, -50%)"}}>
                                                                <div className="modal-content">
                                                                <div className="modal-header">
                                                                    <h4 className="modal-title">Enrolled Courses</h4>
                                                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                                                </div>
                                                                <div className="modal-body">
                                                                {item.coursesOpted && item.coursesOpted.map((optedCourse:any) => {
                                                                    return <>{optedCourse && optedCourse.title ? optedCourse.title+', ':''}</>
                                                                })}
                                                                </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </td> */}
                                                        <td className="text-secondary">{item?.email}</td>
                                                        <td className="text-secondary">{item?.phone}</td>
                                                        <td className="text-center">{item?.status === 'ACTIVE'? <img src={activeBadge}/>: <img src={inactiveBadge}/>}</td>
                                                        <td className="text-secondary">{moment(item?.created_at).format('DD MMMM, YYYY')}</td>
                                                        <td className="text-secondary">
                                                            <div className='d-flex align-items-center'>
                                                                <div className='mr-3'>
                                                                {
                                                                    item.status === 'INACTIVE' ?
                                                                        <Button shape={'circle'} className='btn-danger' onClick={() => {
                                                                            API_SERVICE.activateUser(item.id).then(() => {
                                                                                refreshItems();
                                                                            }).catch((e) => {
                                                                                notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                            });
                                                                        }
                                                                        } icon={<LockFilled />} /> :
                                                                        <Button shape={'circle'} type={'primary'} onClick={() => {
                                                                            API_SERVICE.deactivateUser(item.id).then(() => {
                                                                                refreshItems();
                                                                            }).catch((e) => {
                                                                                notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                            });
                                                                        }
                                                                        } icon={<UnlockFilled />} />
                                                                }
                                                                    {/* <img className='cursor-pointer' src={lockOpen} style={{width:'15px'}} /> */}
                                                                </div>
                                                                <div className='mr-3'>
                                                                    <img className='cursor-pointer' src={viewIcon} style={{width:'20px'}} 
                                                                    onClick={() => {
                                                                        history.push(`/student/${item.id}/view`);
                                                                    }}
                                                                    />
                                                                </div>
                                                                <div className='mr-3'>
                                                                    <img className='cursor-pointer' src={editIcon}  style={{width:'15px'}} 
                                                                    onClick={() => {
                                                                        history.push(`/student/${item.id}/edit`);
                                                                    }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </AuthConsumer>
    );
}
